// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6011":"css/app.6764","9868":"css/admin-app.6764"}[chunkId] + ".css";
};